import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#192f1a',
    },
    secondary: {
      main: '#FFD24D',
    },
  },
});

export default theme;
